import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25103a42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "breadcrumb-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "b-icon arrow_forward"
}

import { useRoute } from 'vue-router';
import { computed, ComputedRef } from 'vue';
import { BreadcrumbItem } from '@/typings';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();

const homeItem = {
  name: 'Home',
  path: '/main'
};

const breadcrumbItems: ComputedRef<BreadcrumbItem[]> = computed(() => {
  const currentItem = {
    name: (route.meta.breadcrumbName || '') as string,
    path: ''
  };

  return [homeItem, currentItem];
});

const isItemLink = (item: BreadcrumbItem) => {
  return item.path !== '' && breadcrumbItems.value.length > 1;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(breadcrumbItems), (item, idx) => {
      return (_openBlock(), _createElementBlock("span", {
        class: "breadcrumb-wrapper__item",
        key: item.name
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(isItemLink(item) ? 'router-link' : 'span'), {
          to: item.path,
          class: _normalizeClass({
          'breadcrumb-wrapper__item__link': isItemLink(item)
        })
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.name), 1)
          ]),
          _: 2
        }, 1032, ["to", "class"])),
        (idx < _unref(breadcrumbItems).length - 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})